import * as flux from 'flux';
import { EventEmitter } from 'eventemitter3';
import GlobalDispatcher from '../dispatcher/Dispatcher';

export function StoreBuilder(dispatcher?: flux.Dispatcher<unknown>) {

    dispatcher = dispatcher || new flux.Dispatcher();

    const CHANGE = 'CHANGE';

    return class BaseStore extends EventEmitter.EventEmitter {
        private _dispatchToken: string;
        protected state: any;
        protected handlers: { [event: string]: any} = {};

        constructor() {
            super();
            this.subscribe(() => this.register);
        }

        getState(): any {
            return this.state;
        }

        private subscribe(actionSubscribe) {
            this._dispatchToken = dispatcher.register(actionSubscribe());
        }

        get dispatchToken() {
            return this._dispatchToken;
        }

        get dispatcher() {
            return dispatcher;
        }

        emitChange() {
            setTimeout(()  => { // Run after dispatcher has finished
                this.emit(CHANGE);
            }, 0);
        }

        addChangeListener(cb: () => void): void {
            this.on(CHANGE, cb);
        }

        removeChangeListener(cb: () => void): void {
            this.removeListener(CHANGE, cb);
        }

        private register = (action: any): void => {
            if (!action) {
                return;
            }

            if (!this.handlers[action.type]) {
                return;
            }

            this.handlers[action.type](action);

            if (action.$callback) {
                action.$callback();
            }
            
        }
    };
}

const BaseStore = StoreBuilder(GlobalDispatcher);

export default BaseStore;
